import { Flex, GridItem, IconButton } from "@chakra-ui/react";
import { PencilSimple, Trash } from "@phosphor-icons/react";
import { EsgLabel } from "../../../../../../components/Forms";

function CategoryGridItems({ items, attributesOrder, handleEditItem, handleDeleteItem, isPreview, organizationStructure, dimensionKeys = [] }) {
  const dimensionKeySet = new Set(dimensionKeys);

  const renderDimensionLabel = (dimKey, rawValue) => {
    const id = rawValue?.toString();
    if (!id || !organizationStructure?.dimensions?.[dimKey]) return "";
    const found = organizationStructure.dimensions[dimKey].items.find(item => item.id.toString() === id);
    return found?.name ?? "";
  };

  return (
    items && items.map(field => {
      const gridItems = [];

      // Putting the grid items in the same order as it's defined in attributesOrder
      attributesOrder.forEach(attribute => {
        const isDimensionAttr = dimensionKeySet.has(attribute);
        const rawValue = isDimensionAttr ? field[`${attribute}Item`] : field[attribute];
        const displayValue = isDimensionAttr ? renderDimensionLabel(attribute, rawValue) : rawValue;
        const labelItem = (
          <EsgLabel
            overflow="hidden"
            fontWeight="normal"
            color="gray.700"
            text={displayValue}
            title={displayValue}
          />
        );
        gridItems.push(labelItem);
      });

      if (!isPreview) {
        gridItems.push(<Flex>
          <IconButton
            type="button"
            icon={<PencilSimple size={18} />}
            variant="ghost"
            color="gray.500"
            _hover={{ color: "limeShade.600" }}
            onClick={() => handleEditItem(field)}
            aria-label="Edit"
          />
          <IconButton
            type="button"
            icon={<Trash size={18} />}
            variant="ghost"
            color="gray.500"
            _hover={{ color: "red.500" }}
            onClick={() => handleDeleteItem(field)}
            aria-label="Delete"
          />
        </Flex>);
      }

      return gridItems.map((gridItem, gridItemIndex) => {
        const numberOfColumns = attributesOrder.length + (!isPreview ? 1 : 0);

        return <GridItem
          key={`category-grid-item-${gridItemIndex}`}
          px={4} py={2}
          display="flex"
          alignItems="center"
          borderBottom="1px solid"
          borderColor="gray.100"
          colSpan={isPreview ? 2 : gridItemIndex === numberOfColumns - 1 ? 1 : 2}
        >
          {gridItem}
        </GridItem>;
      });
    })
  );
}

export default CategoryGridItems;
